export default {
    USD: 1,
    NIS: 2,
    EUR: 3,
    GBP: 4,
    HUF: 5,
    PLN: 6,
    BGN: 7,
    PHP: 8,
    CAD: 9,
    RON: 10,
    CHF: 11,
    CZK: 12,
    ZAR: 13,
    NAD: 14,
    BWP: 15,
    TZS: 16
}
